import { render, staticRenderFns } from "./ModalAdicionarProcedimento.vue?vue&type=template&id=42cc9b17&scoped=true"
import script from "./ModalAdicionarProcedimento.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarProcedimento.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarProcedimento.vue?vue&type=style&index=0&id=42cc9b17&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc9b17",
  null
  
)

export default component.exports